import { render, staticRenderFns } from "./projectPopup.vue?vue&type=template&id=4ce37341&scoped=true&"
import script from "./projectPopup.vue?vue&type=script&lang=ts&"
export * from "./projectPopup.vue?vue&type=script&lang=ts&"
import style0 from "./projectPopup.vue?vue&type=style&index=0&id=4ce37341&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce37341",
  null
  
)

export default component.exports